import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom'
import { useEffect } from 'react'
import { AuthProvider, useAuth } from './context/AuthContext'

import Nav from './components/Nav'
import Footer from './components/Footer'

import Home from './pages/Home'
import News from './pages/News'
import Tour from './pages/Tour'
import Bio from './pages/Bio'
import Music from './pages/Music'
import Videos from './pages/Videos'
import Epk from './pages/Epk'
import Contact from './pages/Contact'
import SignIn from './pages/SignIn'
import SignUp from './pages/SignUp'
import AdminDashboard from './pages/AdminDashboard'
import NotFound from './pages/NotFound'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])
  return null
}

// Pages that skip the main nav/footer
const BARE_ROUTES = ['/signin', '/signup', '/admin', '/admin/bookings', '/admin/users']

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (!user || user.role !== 'admin') return <Navigate to="/signin" state={{ from: '/admin' }} replace />
  return <>{children}</>
}

function Layout() {
  const { pathname } = useLocation()
  const isBare = BARE_ROUTES.some((r) => pathname.startsWith(r))

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <ScrollToTop />
      {!isBare && <Nav />}
      <div style={{ flex: 1 }}>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<News />} />
          <Route path="/tour" element={<Tour />} />
          <Route path="/bio" element={<Bio />} />
          <Route path="/music" element={<Music />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/epk" element={<Epk />} />
          <Route path="/contact" element={<Contact />} />
          {/* Auth */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          {/* Admin */}
          <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="/admin/*" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!isBare && <Footer />}
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </BrowserRouter>
  )
}
